<ngx-spinner bdColor="rgb(250,249,255)" size="default" color="#4589ff" type="square-jelly-box"></ngx-spinner>

<app-header *ngIf="showHeader"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
